module.exports = __webpack_public_path__ + "static/media/saffron_bs.4df8df53.png";